import styled from 'styled-components'

import { Link } from '@subaio/components'

import { helpers } from 'styles'

export const Container = styled(Link)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: 4px;
	width: 100%;
	color: ${helpers.color.text};
	border-radius: 4px;
	padding: 12px 16px;
	text-decoration: none;
	transition: background-color 0.2s;

	&:hover {
		text-decoration: none;
		color: unset;
		background-color: ${helpers.color.linkBackgroundHover};
	}

	&:active,
	&:focus {
		text-decoration: none;
		color: unset;
	}
`
